import '@/ContextTab/hooks/windowListeners'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { Inkline } from '@inkline/inkline'
import { setupCalendar } from 'v-calendar'
import ElementPlus from 'element-plus'
import ElRuLocale from 'element-plus/es/locale/lang/ru'
import App from '@/ContextTab/App.vue'
import { tabMetrics } from '@/ContextTab/services/tabMetrics'
import { router } from '@/router'
import 'virtual:svg-icons-register'
import '@/assets/styles/index.css'
import { initApiClient } from '@/ContextTab/services/apiClient'


if (globalThis.SharedWorker) {
  // must be explicit use of URL inside SharedWorker https://github.com/webpack/webpack/issues/14960
  new SharedWorker(new URL('./Workers/Gateway/index.ts', import.meta.url), {
    type: 'module',
    name: 'PsGatewayWorker',
  })
} else {
  // for mobile devices with no SharedWorker support
  new Worker(new URL('./Workers/Gateway/index.ts', import.meta.url), {
    type: 'module',
    name: 'PsGatewayWorker',
  })
}

const app = createApp(App)

app.use(createPinia())
app.use(Inkline, {
  locale: 'ru',
  size: 'sm',
  colorMode: '',
})
app.use(ElementPlus, { locale: ElRuLocale })
app.use(setupCalendar, {})
app.use(router)

tabMetrics.init(app)
initApiClient()

app.mount('#ps-app')
